import { useLang } from "./LangContext";
import { content } from "@/data/content";

export default function Header() {
  const { lang, setLang, t } = useLang();

  return (
    <header
      data-testid="site-header"
      className="fixed inset-x-0 top-0 z-[100] mix-blend-difference"
    >
      <div className="flex items-center justify-between px-6 py-5 md:px-12">
        <a
          href="#top"
          data-testid="header-wordmark"
          className="font-display text-sm font-bold uppercase tracking-[0.25em] text-white"
        >
          MIDLOWS
        </a>

        <div className="flex items-center gap-6">
          <span className="hidden font-mono text-[0.68rem] uppercase tracking-[0.18em] text-white/70 sm:inline">
            {t.tagline}
          </span>
          <div
            data-testid="lang-toggle"
            className="flex items-center gap-2 font-mono text-[0.72rem] uppercase tracking-[0.18em] text-white"
          >
            {Object.keys(content).map((code, i) => (
              <span key={code} className="flex items-center gap-2">
                {i > 0 && <span className="text-white/40">/</span>}
                <button
                  data-testid={`lang-${code}`}
                  onClick={() => setLang(code)}
                  className={`transition-opacity duration-300 ${
                    lang === code ? "opacity-100" : "opacity-40 hover:opacity-70"
                  }`}
                  aria-label={`Switch language to ${code.toUpperCase()}`}
                  aria-pressed={lang === code}
                >
                  {content[code].langName}
                </button>
              </span>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}
